export default __webpack_public_path__ + "static/media/flanksource.d44c6490.svg";